var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-header d-flex align-items-center justify-content-center py-4"},[_c('img',{staticClass:"auth-header__logo",attrs:{"src":_vm.AppAssets.BRAND.FullWhiteLogo,"alt":"MORIZON EXC logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }